module.exports = "<svg id=\"78316d78-274e-43f6-b250-09aa98eaf38d\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>fb</title><circle cx=\"25\" cy=\"25\" r=\"25\"></circle><path d=\"M27.34,39.84V26.33H28.9c.86,0,1.72,0,2.57,0,.14,0,.37-.16.38-.27.24-1.65.44-3.3.67-5H27.4c0-1.46-.08-2.86,0-4.25.07-1,.67-1.47,1.68-1.57.8-.08,1.61-.07,2.42-.09h1.14V10.43c-.26,0-.51-.08-.76-.09a16.18,16.18,0,0,0-5.68.22A5.9,5.9,0,0,0,22,15.87c-.1,1.51-.07,3-.1,4.55,0,.19,0,.38,0,.62H17.33v5.27h4.48V39.8Z\" style=\"fill: #fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fb.svg
// module id = 556
// module chunks = 1